import { render } from "./PanelDivider.vue?vue&type=template&id=3caf34a0&scoped=true"
import script from "./PanelDivider.vue?vue&type=script&lang=js"
export * from "./PanelDivider.vue?vue&type=script&lang=js"

import "./PanelDivider.vue?vue&type=style&index=0&id=3caf34a0&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2026.30.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3caf34a0"]])

export default __exports__